export default "__VITE_ASSET__DyrRS3n2__"